import { TransTokens } from "../../i18n/trans-tokens";

const tokens = TransTokens.create({
  BaseLoginError: "Something went wrong during login",
  NoPlayServicesError: "Google Play services not installed on this devices.",
  CancelledError: "The login was cancelled",
  InProgressError: "There already is a login in progress",
  FailedError: "Logging in has failed",
  CredentialsError: "Incorrect credentials.",
  AlreadyLoggedInError: "You are already logged in.",
  InvalidMailAddressError: "You entered an invalid e-mail address.",
  ExpiredTokenError: "The token you entered has expired.",
  InvalidTokenError: "The token you entered is invalid or has expired.",
  InvalidSignInLinkError: "The sign-in link is invalid or has expired.",
  NetworkError:
    "We couldn't reach our login server. Please check if you are connected to the internet.",
  InvalidDomainError:
    "Your email domain (the part after the @ symbol, like gmail.com or company.com) isn't allowed. Please use a different email address.",
  InvalidDomainErrorEP:
    "Your email domain (the part after the @ symbol, like gmail.com or company.com) isn't allowed. Please use a different email address or contact programma@energyplatform.nl for help.",
  InvalidEmailError:
    "This email address isn't allowed for this project. Please use a different email address.",
  InvalidEmailErrorEP:
    "This email address isn't allowed for this project. Please use a different email address or contact programma@energyplatform.nl for help.",
  UnauthenticatedError: "You are no longer logged in, please log in again.",
  AnonNetworkError:
    "Something went wrong while connecting, please check your connection.",
  AnonUnknownError: "An unknown error occurred, please try again later.",
});

class BaseLoginError extends Error {
  public name = "LoginError";
  public message = "LoginError";
  public localizedMessage = tokens.BaseLoginError;
}

class UnknownError extends BaseLoginError {}
class NoPlayServicesError extends BaseLoginError {
  public localizedMessage = tokens.NoPlayServicesError;
}
class CancelledError extends BaseLoginError {
  public localizedMessage = tokens.CancelledError;
}
class InProgressError extends BaseLoginError {
  public localizedMessage = tokens.InProgressError;
}
class FailedError extends BaseLoginError {
  public localizedMessage = tokens.FailedError;
}
class CredentialsError extends BaseLoginError {
  public localizedMessage = tokens.CredentialsError;
}
class AlreadyLoggedInError extends BaseLoginError {
  public localizedMessage = tokens.AlreadyLoggedInError;
}
class InvalidMailAddressError extends BaseLoginError {
  public localizedMessage = tokens.InvalidMailAddressError;
}

class ExpiredTokenError extends BaseLoginError {
  public localizedMessage = tokens.ExpiredTokenError;
}

class InvalidTokenError extends BaseLoginError {
  public localizedMessage = tokens.InvalidTokenError;
}

class InvalidSignInLinkError extends BaseLoginError {
  public localizedMessage = tokens.InvalidSignInLinkError;
}

class NetworkError extends BaseLoginError {
  public localizedMessage = tokens.NetworkError;
}

class InvalidDomainError extends BaseLoginError {
  public localizedMessage = tokens.InvalidDomainError;
}

class InvalidDomainErrorEP extends BaseLoginError {
  public localizedMessage = tokens.InvalidDomainErrorEP;
}

class InvalidEmailError extends BaseLoginError {
  public localizedMessage = tokens.InvalidEmailError;
}

class InvalidEmailErrorEP extends BaseLoginError {
  public localizedMessage = tokens.InvalidEmailErrorEP;
}

class UnauthenticatedError extends BaseLoginError {
  public localizedMessage = tokens.UnauthenticatedError;
}

class AnonNetworkError extends BaseLoginError {
  public localizedMessage = tokens.AnonNetworkError;
}

class AnonUnknownError extends BaseLoginError {
  public localizedMessage = tokens.AnonUnknownError;
}

export const LoginError = {
  NoPlayServicesError,
  CancelledError,
  InProgressError,
  FailedError,
  CredentialsError,
  UnknownError,
  AlreadyLoggedInError,
  InvalidMailAddressError,
  NetworkError,
  ExpiredTokenError,
  InvalidTokenError,
  InvalidSignInLinkError,
  InvalidDomainError,
  InvalidDomainErrorEP,
  InvalidEmailError,
  InvalidEmailErrorEP,
  UnauthenticatedError,
  AnonNetworkError,
  AnonUnknownError,
};
